// extracted by mini-css-extract-plugin
export default {"actionIcon":"PennyTransferAction_actionIcon"};